<app-dialog [(visible)]="visible">
  <div class="dialog-content">
    <h2>Create New Campaign</h2>

    <div class="form-group">
      <label for="creator-select">Select a Creator:</label>
      <select id="creator-select" [(ngModel)]="selectedRosterId" class="form-dropdown">
        <option value="">-- Select a Creator --</option>
        <option *ngFor="let roster of sortedRosters" [value]="roster.id">
          {{getCreatorDisplayText(roster)}}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="source-select">Campaign Source:</label>
      <select id="source-select" [(ngModel)]="selectedSource" class="form-dropdown">
        <option value="Inbound">Inbound</option>
        <option value="Outbound">Outbound</option>
        <option *ngFor="let u of castingUsers" [value]="u.id">{{u.firstName}} {{u.lastName}}</option>
      </select>
    </div>

    <div class="form-group">
      <label for="rate-input">Rate ($):</label>
      <input id="rate-input" type="number" [(ngModel)]="rate" min="0" step="0.01" class="form-dropdown" />
    </div>

    <div class="dialog-buttons">
      <button class="btn btn-primary" (click)="onCreateCampaign()" [disabled]="!selectedRosterId">
        Create Campaign
      </button>
      <button class="btn btn-secondary" (click)="onCancel()">
        Cancel
      </button>
    </div>
  </div>
</app-dialog>
